import setting from '@/setting.js'
import APIGoogle from '@/xhr/xhr-googlemap'

export default {
  computed: {
  },

  components: {
    setting
  },

  data () {
    return {
      setting
    }
  },

  methods: {
    async searchAddress (address) {
      const params = {
        address: address,
        language: 'ja',
        sensor: false,
        components: 'country:JP',
        key: setting.googleApiKey
      }
      return APIGoogle.searchAddress({params: params}).then(res => {
        return res
      })
    },

    async getPrefectures () {
      if (window.navigator.onLine) {
        await this.$store.dispatch('prefectures/setPrefectureAction').then(() => {
          this.$store.commit('loadingAction', false)
        }).catch((err) => {
          this.$store.commit('loadingAction', false)
          this.$appNotification.notificationConfirm(`都道府県の取得に失敗しました。 code:${err.status}`, 'エラー')
        })
      } else {
        this.$appNotification.notificationConfirm(`都道府県の取得に失敗しました。`, 'エラー')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/searchAddress.mixin.js